"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const components_1 = require("./components");
const styles_1 = require("../Accordion/styles");
exports.Drawer = (0, react_1.forwardRef)(({ children, position = 'right', handleClickOutside, className, contentStyle, customBackdrop: Drop = components_1.Backdrop, noMaxWidth, visible = true, }, ref) => {
    const [, setLocked] = (0, app_1.useScrollLockManual)(visible);
    (0, react_1.useEffect)(() => {
        setLocked(visible);
        return () => setLocked(false);
    }, [setLocked, visible]);
    return ((0, jsx_runtime_1.jsx)(styles_1.Wrap, Object.assign({ className: className, ref: ref }, { children: (0, jsx_runtime_1.jsxs)(components_1.Absolute, { children: [(0, jsx_runtime_1.jsx)(Drop, { onClick: () => handleClickOutside === null || handleClickOutside === void 0 ? void 0 : handleClickOutside() }), (0, jsx_runtime_1.jsx)(components_1.StyledSection, Object.assign({ "$position": position }, { children: (0, jsx_runtime_1.jsx)(components_1.Full, Object.assign({ "$noMaxWidth": noMaxWidth }, { children: (0, jsx_runtime_1.jsx)(components_1.DrawerContent, Object.assign({ css: contentStyle }, { children: children })) })) }))] }) })));
});
